export const COMBINED_SLIDER_ENUMS = /** @type {const} */({
  TOP_EVENTS: 1,
  BOOSTED_ODDS: 2,
  BANNER: 3,
});